import React from 'react'
import FileInput from 'react-simple-file-input'
import Icons from '../../Icons'
import styled from 'styled-components'



const Add = ({hasCamera, onKeyDown, onAdd, field, onFileLoaded}) =>
  hasCamera ? (
    <Container onClick={onAdd} onKeyDown={onAdd}>
      <Icons icon="PLUS_CIRCLE" />
    </Container>
  ) : (
    <div>
      <StyledLabel htmlFor={field}>
	    <StyledFileInput
	        id={field}
	        name={field}
	        readAs="dataUrl"
	        onLoad={onFileLoaded}
	    	onKeyDown={onKeyDown}
	    />
        <Icons icon="PLUS_CIRCLE" />
      </StyledLabel>
    </div>
  )

export default Add

const StyledLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  :focus-within {
    border: 3px solid #FF9900;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  :focus-within {
    border: 3px solid #FF9900;
  }
`

const StyledFileInput = styled(FileInput)`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  
`
